import React, { useRef, useEffect, useState } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

gsap.registerPlugin(useGSAP);

export default function LoaderUI({ triggerHide }) {
  const containerRef = useRef();
  const loaderRef = useRef();
  const textRef = useRef();

  const [isVisible, setIsVisible] = useState(true);
  const [startTime] = useState(Date.now()); // l'heure d'entrée dans le loader
  const [hasFadedOut, setHasFadedOut] = useState(false);

  // Intro animation
  useGSAP(() => {
    const tl = gsap.timeline();

    tl.to(loaderRef.current, {
      autoAlpha: 1,
      duration: 1,
      ease: "power2.out",
    });

    tl.fromTo(
      textRef.current,
      { y: 20, autoAlpha: 0 },
      { y: 0, autoAlpha: 1, duration: 0.8 },
      "-=0.5"
    );
  }, []);

  // FadeOut logic
  useEffect(() => {
    if (triggerHide && !hasFadedOut) {
      const now = Date.now();
      const elapsed = now - startTime;
      const minDuration = 4000;

      const delay = Math.max(0, minDuration - elapsed);

      const timeout = setTimeout(() => {
        setHasFadedOut(true); // évite de re-trigger

        gsap.to(containerRef.current, {
          yPercent: -100,
          duration: 0.3,
          ease: "power2.In",
          onComplete: () => setIsVisible(false), // démonter après anim
        });
      }, delay);

      return () => clearTimeout(timeout);
    }
  }, [triggerHide, startTime, hasFadedOut]);

  if (!isVisible) return null;

  return (
    <div className="loader-ui" ref={containerRef}>
      <div className="container">
        <div className="loader" ref={loaderRef}>
          <div className="shadow"></div>
        </div>
        <div ref={textRef} className="loading-text">
          Chargement de l’expérience
        </div>
      </div>
    </div>
  );
}
